<div class="wizard-step-container">
  <div class="start-step-container">
    <div class="start-step-banner-img">
    <img class="wizard-start-page-banner-img" src="../../../assets/images/start-banner.png" 
    /></div>
    <div class="start-step-contents">
      <div class="wizard-step-header is-start-step">
        <h1 class="wizard-step-title start-wizard-step-title" role="heading" aria-level="1" [attr.aria-label]="title">{{title}}</h1>
        <p class="wizard-step-subtitle start-wizard-step-subtitle" role="heading" aria-level="2" [attr.aria-label]="subtitle">{{subtitle}}</p>
      </div>
      <div class="start-page-nav">
        <app-wizard-navigation
          [currentStepName]="analyticsStepName"
          [isStartStep]="true"
          [nextStepRoute]="'/primary-use'"
          [hideBackButton]="true"></app-wizard-navigation>
      </div>
      <div class="start-step-flex-container" *ngIf="showFlexLink">
        <div class="flex-information">
          <p>
          Not Ready? Try
          <a (click)="logLinkClick()">
             ChromeOS Flex
            </a>
            on your existing Windows and Mac devices today.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
